import React from 'react';
import {Icon} from 'semantic-ui-react';

const mailId = "mailto:tusuveltu@gmail.com?subject=Query&body=Hello%20goes%20here";;
const FacebookUrl = "https://www.facebook.com/Ahanas-sajghor-100583738717343/";
const whatsAppUrl = "https://api.whatsapp.com/send?phone=919734065582&amp;text=Hi,%2we%20use%20ToChat.Be";
const phone = "tel:+919734065582";


const SocialMedia = ({color, inverted=false}) => (
  <Icon.Group as="Container">
    <Icon style={styles.button} inverted={inverted} color={color} name="facebook" circular onClick={()=> window.open(FacebookUrl)} link size="big" />
    <Icon style={styles.button} inverted={inverted} color={color} name="mail" circular onClick={()=> window.open(mailId)} link size="big" />
    <Icon style={styles.button} inverted={inverted} color={color} name="whatsapp" circular onClick={()=> window.open(whatsAppUrl)} link size="big" />
    <Icon style={styles.button} inverted={inverted} color={color} name="phone" circular onClick={()=> window.open(phone)} link size="big" />
  </Icon.Group>
);

const styles = {
  button: {
    margin: '2px'
  }
}
export {SocialMedia};